import React, { useEffect, useState } from 'react';
import './LessonText.scss';
import ReactMarkdown from 'react-markdown';
import rehypeSanitize from 'rehype-sanitize';
import Skeleton from '../../../../components/Skeleton/Skeleton';
import { safeHtml } from '../../../../services/helpers';


export default function LessonText({ selectedTrainingLesson }) {

    const [formatedText, setFormatedText] = useState()

    useEffect(() => {
        if (selectedTrainingLesson && selectedTrainingLesson.text) {
            setFormatedText(selectedTrainingLesson.text.split('\n'));
        } else (
            setFormatedText('')
        )
    }, [selectedTrainingLesson])

    console.log('selectedTrainingLesson', selectedTrainingLesson)


    return (
        <>
            {
                selectedTrainingLesson ?
                    selectedTrainingLesson.text &&
                        <div className="training-lesson-text" dangerouslySetInnerHTML={safeHtml(selectedTrainingLesson.text)} />
                        
                :
                    <Skeleton
                        width='100%'
                        height='300px'
                        borderRadius='1rem'
                        bkgColor='#EEE6DB'
                        animColor='#F5F0ED'
                    />
            }
        </>
    )
}
